var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _c("div", { staticClass: "zgc-title" }, [_vm._v(_vm._s(_vm.title))]),
    _c(
      "div",
      { staticClass: "form-box" },
      [
        _vm.showLogin
          ? _c(
              "div",
              [
                _c("div", { staticClass: "welcome" }, [_vm._v("欢 迎 登 陆")]),
                _c(
                  "el-form",
                  {
                    ref: "loginForm",
                    staticClass: "login-form",
                    attrs: {
                      model: _vm.loginForm,
                      "auto-complete": "on",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "login-form-item",
                        attrs: { prop: "username" }
                      },
                      [
                        _c("span", { staticClass: "svg-container" }, [
                          _c("i", { staticClass: "iconfont iconuser1" })
                        ]),
                        _c("el-input", {
                          ref: "username",
                          attrs: {
                            placeholder: "账号",
                            name: "username",
                            type: "text",
                            tabindex: "1",
                            "auto-complete": "on"
                          },
                          model: {
                            value: _vm.loginForm.username,
                            callback: function($$v) {
                              _vm.$set(_vm.loginForm, "username", $$v)
                            },
                            expression: "loginForm.username"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "login-form-item",
                        attrs: { prop: "password" }
                      },
                      [
                        _c("span", { staticClass: "svg-container" }, [
                          _c("i", { staticClass: "iconfont iconpassword" })
                        ]),
                        _c("el-input", {
                          key: _vm.passwordType,
                          ref: "password",
                          attrs: {
                            type: _vm.passwordType,
                            placeholder: "密码",
                            name: "password",
                            tabindex: "2",
                            "auto-complete": "on"
                          },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleLogin($event)
                            }
                          },
                          model: {
                            value: _vm.loginForm.password,
                            callback: function($$v) {
                              _vm.$set(_vm.loginForm, "password", $$v)
                            },
                            expression: "loginForm.password"
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "show-pwd",
                            on: { click: _vm.showPwd }
                          },
                          [
                            _c("i", {
                              class: [
                                "iconfont",
                                _vm.passwordType === "password"
                                  ? "iconeye1"
                                  : "iconeye"
                              ]
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "login-btn",
                            staticStyle: { width: "100%" },
                            attrs: { loading: _vm.loading, type: "primary" },
                            on: { click: _vm.handleLogin }
                          },
                          [_vm._v("登录")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _c("ModifyPwdForm"),
        _c(
          "el-button",
          {
            attrs: { type: "text" },
            on: {
              click: function($event) {
                _vm.showLogin = !_vm.showLogin
              }
            }
          },
          [_vm._v(_vm._s(_vm.showLogin ? "忘记密码" : "返回登陆"))]
        )
      ],
      1
    ),
    _c("div", { staticClass: "footer" }, [
      _c("span", [
        _vm._v(
          "© 2023-2028 " +
            _vm._s(_vm.title) +
            " 技术支持：湖北盈诺网络科技有限公司 "
        )
      ]),
      _c(
        "a",
        {
          staticStyle: { "margin-left": "10px" },
          attrs: { target: "_blank", href: "https://beian.miit.gov.cn" }
        },
        [_vm._v("鄂ICP备20007476号")]
      ),
      _c("img", { attrs: { src: require("../../image/ba.png"), alt: "" } }),
      _c(
        "a",
        {
          staticStyle: { "margin-left": "5px" },
          attrs: {
            target: "_blank",
            href:
              "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42050202000528"
          }
        },
        [_vm._v("鄂公网安备 42050202000528号")]
      )
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "box",
        on: { click: _vm.bg }
      },
      [
        _c("div", { staticClass: "box-info" }, [
          _c("div", { ref: "qrCodeUrl", staticClass: "qrcode" })
        ]),
        _c("p", { staticClass: "title" }, [
          _vm._v("请扫描二维码，进行人脸识别鉴权")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }